export const forgotUsername =
  'https://studentaid.gov/fsa-id/sign-in/retrieve-username';
export const forgotPassword =
  'https://studentaid.gov/fsa-id/sign-in/account-lookup';
